import { FC } from 'react'
import Popup from 'components/features/pfm/Popup/Popup'
import * as styles from 'components/features/pfm/UpdateNowPopup/UpdateNowPopup.styl'
import Button from 'components/features/pfm/Button/Button'
import { connect, MapDispatchToPropsFunction } from 'react-redux'
import { resetFinancialStateActionCreator } from 'actions/globalActions'
import { confirmUpdatePopupActionCreator } from 'actions/flushDateActions'

const emptyFn = () => { /* do nothing */}

type UpdateNowPopupDispatchProps = {
  onUpdate: () => void
}

type UpdateNowPopupProps =
  & UpdateNowPopupDispatchProps

const UpdateNowPopupComponent: FC<UpdateNowPopupProps> = ({
  onUpdate,
}) => {
  return (
    <Popup onCloseButtonClick={ emptyFn } undismissible>
      <div className={ styles.header }>
        <div className={ styles.title }>
          New data is available.
        </div>
        <div className={ styles.subtitle }>
          Click ‘Update Now’ to see the latest numbers.
        </div>
      </div>
      <div className={ styles.contentWrapper }>
        <div className={ styles.buttonWrapper }>
          <Button
            fullWidth
            qaMarker='update-now'
            onClick={ onUpdate }
          >
            UPDATE NOW
          </Button>
        </div>
      </div>
    </Popup>
  )
}


const mapDispatchToProps: MapDispatchToPropsFunction<UpdateNowPopupDispatchProps> = (dispatch) => ({
  onUpdate: () => {
    dispatch(resetFinancialStateActionCreator())
    dispatch(confirmUpdatePopupActionCreator({ isShown: false }))
  },
})

const UpdateNowPopup = connect<{}, UpdateNowPopupDispatchProps>(undefined, mapDispatchToProps)(UpdateNowPopupComponent)

export default UpdateNowPopup
